var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FC3C3C",
  d: "M12 6.514c0 2.103-1.005 4.321-2.906 6.416-1.42 1.563-2.82 2.502-2.878 2.541a.39.39 0 0 1-.432 0c-.06-.039-1.46-.978-2.878-2.54C1.005 10.834 0 8.616 0 6.513c0-2.837 1.23-4.397 2.264-5.207A6.2 6.2 0 0 1 4.992.097 6 6 0 0 1 6 0c.484 0 2.187.094 3.736 1.307C10.769 2.117 12 3.677 12 6.514"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEF5FF",
  d: "M8.663 5.98a2.667 2.667 0 0 1-3.417 2.555A2.67 2.67 0 0 1 3.338 5.98 2.67 2.67 0 0 1 6 3.314 2.667 2.667 0 0 1 8.663 5.98"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D0E8F7",
  d: "M8.66 5.98a2.667 2.667 0 0 1-3.416 2.555A2.67 2.67 0 0 0 7.153 5.98a2.67 2.67 0 0 0-1.909-2.556q.36-.109.754-.11A2.667 2.667 0 0 1 8.661 5.98"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#CE3636",
  d: "M12 6.514c0 2.103-1.005 4.321-2.906 6.416-1.419 1.563-2.819 2.502-2.878 2.541a.4.4 0 0 1-.216.066C14.42 6.228 9.35.87 4.992.097A6 6 0 0 1 6 0c.485 0 2.188.094 3.736 1.307C10.77 2.117 12 3.677 12 6.514"
})));
export default SvgLocationRed;